'use client'

import { FunctionComponent, ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useSnapshot } from 'valtio'

import store from '@/store'
import Splash from '@/components/splash/Splash'
import isPlatformAdmin from '@/utils/platformAdmin'

interface RequirePlatformAdminProps {
  children: ReactNode
}

const RequirePlatformAdmin: FunctionComponent<RequirePlatformAdminProps> = ({ children }) => {
  const { currentUser } = useSnapshot(store)

  // `currentUser` is null until Auth0 resolves and the company list loads.
  // Redirecting in that window would bounce real admins on every hard refresh,
  // so hold on the splash instead of deciding too early.
  if (!currentUser) {
    return <Splash text="Loading..." />
  }

  if (!isPlatformAdmin(currentUser)) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default RequirePlatformAdmin
